import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { Component } from 'react';
import { BASE_PLOT_OPTIONS, CHART_BASE_CONFIG, X_AXIS_BASE_CONFIG, Y_AXIS_BASE_CONFIG } from './ChartBaseConfig';

export default class Prediction extends Component {
	chart;
	offset;
	state = {
		options: this.getChartOptions()
	}
	updateDimensions() {
		this.offset = this.chart.container.parentElement.clientWidth;
		this.chart.setSize(this.props.data.length * (this.offset / this.props.frameRate));
		this.translateChart(this.props.currentDataIndex);
	}
	componentDidMount() {
		window.addEventListener("resize", this.updateDimensions.bind(this));
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions.bind(this));
	}
	getChartOptions() {
		return {
			...CHART_BASE_CONFIG,
			chart: {
				backgroundColor: null,
				animation: false,
				margin: [0, 0, 0, 0],
				width: this.props.data.length * 6
			},
			tooltip: {
				animation: false,
				borderColor: 'white',
				shared: true,
				useHTML: true,
				formatter: function() {
					var s = '';
					this.points.forEach((point) => {
						if (point.series.name.indexOf('areainterval') === -1) {
							s += `<div><span style="color: ${point.series.color}">${point.series.name}</span>: ${Math.round(point.y * 1e3) / 1e3}</div>`;
						}
					});
					return s;
				}
			},
			series: [{
				data: this.props.data.map(a => [a.timestamp, a.prediction]),
				type: 'spline',
				name: 'Prediction',
				enableMouseTracking: false,
				color: this.props.lineColor //getColorGradient(this.props.lineColor, false),
			}],
			plotOptions: {
				...BASE_PLOT_OPTIONS
			},
			xAxis: [{
				...X_AXIS_BASE_CONFIG,
				type: this.props.logarithmic ? 'logarithmic' : undefined,
			}],
			yAxis: [{
				...Y_AXIS_BASE_CONFIG,
				min: this.props.minsAndMaxes.min,
				max: this.props.minsAndMaxes.max,
			}]
		};
	}
	componentDidUpdate(prevProps) {
		if (this.props.videoReady !== prevProps.videoReady && this.props.videoReady) {
			setTimeout(() => {
				this.chart.reflow();
				this.updateDimensions();
			}, 1000);
		}

	}
	shouldComponentUpdate(nextProps){
		if (this.chart && this.props.currentDataIndex !== nextProps.currentDataIndex) {
			this.translateChart(nextProps.currentDataIndex)
		}
		return this.props.videoReady !== nextProps.videoReady && nextProps.videoReady;
	}
	translateChart(currentDataIndex) {
		this.chart.container.style.transform = `translateX(${
			- ((this.chart.container.clientWidth / this.props.data.length) * currentDataIndex) + this.offset
		}px) translateZ(0)`;
	}
	chartCallback(chart) {
		this.chart = chart;
		this.chart.container.style.transform = 'translateX(1000px)';
	}
	render() {
		return (
			<HighchartsReact
				highcharts={Highcharts}
				options={this.state.options}
				callback={this.chartCallback.bind(this)}
			/>
		);
	}
}